/* global google */

class LoginController {
    /**
     * @param authService
     */
    constructor($mdToast, $location, authService) {
        this.$mdToast = $mdToast;
        this.$location = $location;
        this.authService = authService;
        this.credentials = {};
        this.terms = false;
        if (this.$location.search().auth) {
            $mdToast.show(
                $mdToast.simple()
                    .textContent('Unauthorized access. Your session timed out.')
                    .position('top center')
                    .action('Hide')
                    .hideDelay(4000)
                    .toastClass('error-toast'),
            );
        }
    }

    $onInit() {
        this.init();
    }

    init() {
        this.authService.init(google, 'login')
        this.accepted = this.$location.search().accepted != null;
    }

    onLogInButtonClick() {
        this.authService.loginOrRegister(false, this.credentials)
            .catch(() => {
                console.error('Can not connect to the database');
            });
    }
}

LoginController.$inject = ['$mdToast', '$location', 'AuthService'];

export default LoginController;



// WEBPACK FOOTER //
// ./src/app/pages/login/loginController.js